export default __webpack_public_path__ + "static/media/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0004.a8c1086f.jpg";